<div *ngIf="user$ | async">
  <user-preview
    [style.top.px]="top$ | async"
    [style.left.px]="left$ | async"
    [user]="user$ | async"
    (mouseleave)="hidePreview(null)"
  ></user-preview>
</div>
